import { Component, OnInit } from "@angular/core";

import { BaseComponent, UserService, HelperService, environment, ProductService, ContentService } from "@mypxplat/xplat/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppService } from "@mypxplat/xplat/web/core";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "myp-edit-profile",
  templateUrl: "edit-profile.component.html",
  standalone: false,
})
export class EditProfileComponent extends BaseComponent implements OnInit {
  public displayedSection;
  public env = environment;

  constructor(
    public userService: UserService,
    public helperService: HelperService,
    private _router: Router,
    private _route: ActivatedRoute,
    public appService: AppService,
    public spinner: NgxSpinnerService,
    public productService: ProductService,
    public contentService: ContentService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.displayedSection = this._route.snapshot.params["category"];
    this.changeCategory(this.displayedSection, false);
  }

  changeCategory(section, nav = true) {
    this.displayedSection = section;
    if (nav) this._router.navigate(["account/", section], { replaceUrl: true });
  }

  upgrade() {
    this._router.navigate(["/onboarding"], { queryParams: { subscribeOnly: true } });
  }
}
